import { Habit } from './types';
import { HabitType } from './types';

export const LATEST_UPDATE = "🧈 iOS: Silky smooth scroll — eliminated nav bar animation jitter!";

export const TRANSLATIONS = {
  en: {
    title: "Haseeb",
    home: "Home",
    analytics: "Analytics",
    profile: "Profile",
    stats: "Statistics",
    streak: "Streak",
    activeHabits: "Active Habits",
    completionRate: "Completion",
    missed: "Missed",
    late: "Late",
    onTime: "On Time",
    inGroup: "In Group",
    takbirah: "Takbirah",
    jamaa: "In Group",
    done: "Done",
    skip: "Skip",
    fail: "Fail",
    undo: "Undo",
    generateInsights: "Generate AI Insights",
    insightsLoading: "Consulting AI...",
    insightsError: "Could not generate insights.",
    welcome: "Welcome back",
    setupProfile: "Please set up your profile",
    language: "Language",
    gender: "Gender",
    male: "Male",
    female: "Female",
    seedData: "Seed Demo Data",
    seedSuccess: "Demo data added!",
    habitAdded: "Habit added!",
    today: "Today",
    createHabit: "Create Habit",
    editHabit: "Edit Habit",
    habitName: "Habit Name",
    habitType: "Type",
    regular: "Regular",
    counter: "Counter",
    target: "Daily Target",
    cancel: "Cancel",
    create: "Create",
    update: "Update",
    save: "Save",
    selectApiKey: "Select API Key",
    insightsTitle: "Spiritual Insights",
    score: "Score",
    perfectRate: "Perfect Rate",
    overallPerformance: "Overall Performance",
    perfectLogs: "Perfect Logs",
    monthlyView: "Monthly View",
    prayersMonthlyView: "Prayers Monthly View",
    rawatibMonthlyView: "Rawatib Monthly View",
    fajr: "Fajr",
    dhuhr: "Dhuhr",
    asr: "Asr",
    maghrib: "Maghrib",
    isha: "Isha",
    allPrayers: "All Prayers",
    bestStreak: "Best Streak",
    chancesLeft: "Chances Left (75y)",
    setDob: "Set Date of Birth",
    remaining: "Remaining",
    dobTitle: "Set Date of Birth",
    dobDesc: "To calculate your remaining prayer chances until age 75, please enter your date of birth.",
    growth: "Growth",
    wow: "WoW",
    mom: "MoM",
    qoq: "QoQ",
    yoy: "YoY",
    enterInCurrentLang: "Please enter name in",
    translating: "Translating habits...",
    activateAll: "Activate All",
    deactivateAll: "Deactivate All",
    lifeCountdown: "Lifetime Countdown (to 75)",
    secs: "Secs",
    mins: "Mins",
    hours: "Hours",
    days: "Days",
    months: "Months",
    years: "Years",
    ramadans: "Ramadans",
    hajjs: "Hajjs",
    fridays: "Fridays",
    monThu: "Mon & Thu",
    whiteDays: "White Days",
    continueWithGoogle: "Continue with Google",
    or: "Or continue with email",
    signIn: "Sign In",
    createAccount: "Create Account",
    emailLabel: "Email Address",
    nameLabel: "Full Name",
    dobLabel: "Date of Birth (Optional)",
    dobHint: "Used for lifetime stats calculation",
    getStarted: "Get Started",
    habitAnalytics: "Habit Analytics",
    topStreaks: "Top Streaks",
    completionTrend: "Completion Trend (7 Days)",
    detailedAnalysis: "Detailed Analysis",
    total: "Total",
    rate: "Rate",
    alreadyHaveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    signUp: "Sign Up",
    submit: "Submit",
    saveProgress: "Save Progress",
  },
  ar: {
    title: "حسيب",
    home: "الرئيسية",
    analytics: "تحليلات",
    profile: "الملف الشخصي",
    stats: "إحصائيات",
    streak: "تتابع",
    activeHabits: "عادات نشطة",
    completionRate: "إنجاز",
    missed: "فائتة",
    late: "قضاء",
    onTime: "في الوقت",
    inGroup: "جماعة",
    takbirah: "بالتكبيرة",
    jamaa: "جماعة",
    done: "تم",
    skip: "تخطي",
    fail: "لم يتم",
    undo: "تراجع",
    generateInsights: "توليد رؤى بالذكاء الاصطناعي",
    insightsLoading: "جار التحليل...",
    insightsError: "تعذر توليد الرؤى.",
    welcome: "أهلاً بك",
    setupProfile: "يرجى إعداد ملفك الشخصي",
    language: "اللغة",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    seedData: "إضافة بيانات تجريبية",
    seedSuccess: "تم إضافة البيانات!",
    habitAdded: "تمت إضافة العادة!",
    today: "اليوم",
    createHabit: "إنشاء عادة",
    editHabit: "تعديل العادة",
    habitName: "اسم العادة",
    habitType: "النوع",
    regular: "عادية",
    counter: "عداد",
    target: "الهدف اليومي",
    cancel: "إلغاء",
    create: "إنشاء",
    update: "تحديث",
    save: "حفظ",
    selectApiKey: "اختر مفتاح API",
    insightsTitle: "رؤى روحانية",
    score: "النتيجة",
    perfectRate: "معدل الكمال",
    overallPerformance: "الأداء العام",
    perfectLogs: "سجلات كاملة",
    monthlyView: "التقويم الشهري",
    prayersMonthlyView: "تقويم الصلوات الشهري",
    rawatibMonthlyView: "تقويم الرواتب الشهري",
    fajr: "الفجر",
    dhuhr: "الظهر",
    asr: "العصر",
    maghrib: "المغرب",
    isha: "العشاء",
    allPrayers: "الصلوات الخمس",
    bestStreak: "أفضل تتابع",
    chancesLeft: "فرص متبقية (75 سنة)",
    setDob: "تحديد تاريخ الميلاد",
    remaining: "متبقي",
    dobTitle: "تحديد تاريخ الميلاد",
    dobDesc: "لحساب فرص الصلاة المتبقية حتى سن 75، يرجى إدخال تاريخ ميلادك.",
    growth: "النمو",
    wow: "أسبوعي",
    mom: "شهري",
    qoq: "ربعي",
    yoy: "سنوي",
    enterInCurrentLang: "يرجى إدخال الاسم بـ",
    translating: "جار ترجمة العادات...",
    activateAll: "تفعيل الكل",
    deactivateAll: "تعطيل الكل",
    lifeCountdown: "العد التنازلي للعمر (حتى ٧٥)",
    secs: "ثانية",
    mins: "دقيقة",
    hours: "ساعة",
    days: "يوم",
    months: "شهر",
    years: "سنة",
    ramadans: "رمضان",
    hajjs: "حج",
    fridays: "جمعة",
    monThu: "إثنين وخميس",
    whiteDays: "أيام بيض",
    continueWithGoogle: "المتابعة باستخدام Google",
    or: "أو باستخدام البريد الإلكتروني",
    signIn: "تسجيل الدخول",
    createAccount: "إنشاء حساب",
    emailLabel: "البريد الإلكتروني",
    nameLabel: "الاسم الكامل",
    dobLabel: "تاريخ الميلاد (اختياري)",
    dobHint: "يستخدم لحساب احصائيات العمر",
    getStarted: "البدء",
    habitAnalytics: "إحصائيات العادات",
    topStreaks: "أفضل التتابعات",
    completionTrend: "معدل الإنجاز (٧ أيام)",
    detailedAnalysis: "تحليل تفصيلي",
    total: "المجموع",
    rate: "المعدل",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    noAccount: "ليس لديك حساب؟",
    signUp: "تسجيل حساب جديد",
    submit: "إرسال",
    saveProgress: "حفظ التقدم",
  }
};

export const INITIAL_HABITS: Habit[] = [
  // Fajr Block
  { id: 'fajr', name: 'Fajr', nameAr: 'الفجر', type: HabitType.PRAYER, isActive: true, order: 100 },
  { id: 'fajr_sunnah', name: 'Fajr Sunnah', nameAr: 'سنة الفجر', type: HabitType.REGULAR, icon: 'Sun', color: '#B8942E', isActive: true, order: 110, presetId: 'rawatib', requireReason: true },
  
  // Morning & Evening (Twice Daily)
  { id: 'athkar_twice_daily', name: 'Athkar (AM/PM)', nameAr: 'أذكار الصباح والمساء', type: HabitType.COUNTER, dailyTarget: 2, icon: 'Sun', color: '#B8942E', isActive: false, order: 120 },
  { id: 'dhuha', name: 'Dhuha Prayer', nameAr: 'صلاة الضحى', type: HabitType.REGULAR, icon: 'Sparkles', color: '#E4C576', isActive: false, order: 130 },

  // Dhuhr Block
  { id: 'dhuhr', name: 'Dhuhr', nameAr: 'الظهر', type: HabitType.PRAYER, isActive: true, order: 200 },
  { id: 'dhuhr_sunnah_before_1', name: 'Dhuhr Sunnah Before (2)', nameAr: 'سنة الظهر القبلية (٢)', type: HabitType.REGULAR, icon: 'Star', color: '#4E8CB4', isActive: true, order: 210, presetId: 'rawatib', requireReason: true },
  { id: 'dhuhr_sunnah_before_2', name: 'Dhuhr Sunnah Before (2)', nameAr: 'سنة الظهر القبلية (٢)', type: HabitType.REGULAR, icon: 'Star', color: '#4E8CB4', isActive: true, order: 220, presetId: 'rawatib', requireReason: true },
  { id: 'dhuhr_sunnah_after', name: 'Dhuhr Sunnah After (2)', nameAr: 'سنة الظهر البعدية (٢)', type: HabitType.REGULAR, icon: 'Star', color: '#4E8CB4', isActive: true, order: 230, presetId: 'rawatib', requireReason: true },

  // Asr Block
  { id: 'asr', name: 'Asr', nameAr: 'العصر', type: HabitType.PRAYER, isActive: true, order: 300 },

  // Maghrib Block
  { id: 'maghrib', name: 'Maghrib', nameAr: 'المغرب', type: HabitType.PRAYER, isActive: true, order: 400 },
  { id: 'maghrib_sunnah', name: 'Maghrib Sunnah', nameAr: 'سنة المغرب', type: HabitType.REGULAR, icon: 'Star', color: '#7E5E14', isActive: true, order: 410, presetId: 'rawatib', requireReason: true },

  // Isha Block
  { id: 'isha', name: 'Isha', nameAr: 'العشاء', type: HabitType.PRAYER, isActive: true, order: 500 },
  { id: 'isha_sunnah', name: 'Isha Sunnah', nameAr: 'سنة العشاء', type: HabitType.REGULAR, icon: 'Star', color: '#235882', isActive: true, order: 510, presetId: 'rawatib', requireReason: true },

  // Night / Sleep
  { id: 'witr', name: 'Witr', nameAr: 'الوتر', type: HabitType.REGULAR, icon: 'Heart', color: '#B4526A', isActive: false, order: 600 },
  { id: 'qiyam', name: 'Qiyam (Night Prayer)', nameAr: 'قيام الليل', type: HabitType.REGULAR, icon: 'Sparkles', color: '#33488A', isActive: false, order: 610 },
  { id: 'surat_mulk', name: 'Surat Al-Mulk', nameAr: 'سورة الملك', type: HabitType.REGULAR, icon: 'BookOpen', color: '#101C4A', isActive: false, order: 620 },
  { id: 'sleep_athkar', name: 'Sleep Athkar', nameAr: 'أذكار النوم', type: HabitType.REGULAR, icon: 'BedDouble', color: '#4E8CB4', isActive: false, order: 630 },
  { id: 'quran', name: 'Quran Recitation', nameAr: 'تلاوة القرآن', type: HabitType.REGULAR, icon: 'Book', color: '#33488A', isActive: false, order: 640 },

  // Fasting (Conditional Visibility)
  { id: 'fasting_monday', name: 'Fasting Monday', nameAr: 'صيام الإثنين', type: HabitType.REGULAR, icon: 'Utensils', color: '#B8942E', isActive: false, order: 700 },
  { id: 'fasting_thursday', name: 'Fasting Thursday', nameAr: 'صيام الخميس', type: HabitType.REGULAR, icon: 'Utensils', color: '#B8942E', isActive: false, order: 710 },
  { id: 'fasting_white_days', name: 'White Days Fasting', nameAr: 'صيام الأيام البيض', type: HabitType.REGULAR, icon: 'Moon', color: '#33488A', isActive: false, order: 720 },
];